const access = {
  entities: [
    { label: 't(Services)', code: 'services' }
  ], 
  rights: [] 
}

export default access
